__turbopack_context__.v({
  "Blockquote": "Copy-module-sass-module__lYs25a__Blockquote",
  "Copy": "Copy-module-sass-module__lYs25a__Copy",
  "Image": "Copy-module-sass-module__lYs25a__Image",
  "ImageGallery": "Copy-module-sass-module__lYs25a__ImageGallery",
  "IsProject": "Copy-module-sass-module__lYs25a__IsProject",
  "NoCaption": "Copy-module-sass-module__lYs25a__NoCaption",
});
